import { buildAdvisorMatchUrl } from '@ria-client/advisor-search/constants';
import { ArrowRight } from 'lucide-react';
import { useAdUrl } from '../../lib/use-ad-url';
import { useTrackedElement } from './use-tracked-element';

export function NwaBanner({ displayName }: { displayName: string }) {
  // useAdUrl adds utm_source (current page) + anonymous id, matching the NWA sticky banner.
  const href = useAdUrl(
    buildAdvisorMatchUrl({ utmCampaign: 'product-card', utmContent: displayName }),
  );
  const { ref, track } = useTrackedElement('nwa_product_card_banner', href);

  return (
    <a
      className="group relative flex items-center gap-3 overflow-hidden bg-[var(--content-blue)] px-4 py-2 text-white no-underline transition-colors hover:bg-[var(--content-blue-dark)] hover:text-white focus-visible:focus-ring @xl:px-5 @3xl:px-6"
      href={href}
      onClick={() => track()}
      ref={ref}
    >
      <span
        aria-hidden
        className="pointer-events-none absolute -top-14 -right-8 size-28 rounded-full bg-white/10"
      />
      <span className="relative flex-1 font-sans text-[13px] leading-snug font-bold @xl:text-sm">
        Get matched with a financial advisor
      </span>
      <span className="relative flex items-center gap-2.5">
        <span className="rounded-sm border border-white/50 px-1 py-px text-[10px] leading-none font-semibold tracking-wide text-white/80 uppercase">
          Ad
        </span>
        <span
          aria-hidden
          className="flex size-7 shrink-0 items-center justify-center rounded-full bg-white text-[var(--content-blue)] transition-transform group-hover:translate-x-0.5"
        >
          <ArrowRight size={16} strokeWidth={2.5} />
        </span>
      </span>
    </a>
  );
}
